import React from 'react'
import './NaborFormular.css'

const BRANDED_FORMS = {
  bullyproof: {
    title: 'Gracie Bullyproof',
    form: 'bully-proof',
    logoUrl: 'https://nbg1.your-objectstorage.com/k8s-steamo-bck/programs/e7ecbc42-5ae6-47f9-afb6-61fdc99e5025.webp',
    logoAlt: 'BULLY PROOF 2026/2027',
  },
  'gracie combatives': {
    title: 'Gracie Combatives',
    form: 'gracie-combatives',
    logoUrl: 'https://nbg1.your-objectstorage.com/k8s-steamo-bck/programs/5d9de302-0564-44bd-ab85-a331f9ffa67f.webp',
    logoAlt: 'Gracie Combatives',
  },
  'women empowered': {
    title: 'Women Empowered',
    form: 'women-empowered',
    logoUrl: 'https://nbg1.your-objectstorage.com/k8s-steamo-bck/programs/1fbd44dc-839a-4106-bd4a-203d447997c6.webp',
    logoAlt: 'Women Empowered',
  },
  mastercycle: {
    title: 'Master Cycle',
    form: 'master-cycle',
    logoUrl: 'https://nbg1.your-objectstorage.com/k8s-steamo-bck/programs/72b696c9-0d19-40bc-b2a2-f6c7d34e8a1b.webp',
    logoAlt: 'Master Cycle',
  },
}

const NaborFormular = ({ eventName, eventNames }) => {
  const requestedEventNames = Array.isArray(eventNames) && eventNames.length > 0
    ? eventNames
    : [eventName]
  const brandedForms = Array.from(new Map(
    requestedEventNames
      .map((name) => BRANDED_FORMS[String(name || '').toLowerCase()])
      .filter(Boolean)
      .map((form) => [form.form, form]),
  ).values())
  const formKey = brandedForms[0]?.form || 'application'
  const publicFormUrl = `https://app.bjjlevice.sk/public/application-access?form=${formKey}&lang=sk&source=bjjlevice_web`
  const registrationHeading = (
    <div className="kl-title-block text-center">
      <h3 className="tbk__title fs-xxl fw-thin">
        <span className="fw-semibold fs-xxxl fs-xs-xl tcolor">Prihláška</span>{' '}
        na skúšobný tréning
      </h3>
    </div>
  )

  if (brandedForms.length > 0) {
    return (
      <section id="prihlaska" className="hg_section nabor-formular--full-width">
        <div className="container">
          {registrationHeading}
          <div className="nabor-formular__widgets">
            {brandedForms.map((brandedForm) => (
              <div className="nabor-formular__program" key={brandedForm.form}>
                <h4 className="nabor-formular__program-title">{brandedForm.title}</h4>
                <div
                  className="nabor-formular__widget"
                  data-steamo-registration
                  data-form={brandedForm.form}
                  data-locale="sk"
                  data-variant="branded"
                  data-logo-url={brandedForm.logoUrl}
                  data-logo-alt={brandedForm.logoAlt}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    )
  }

  // const onSubmit = (values) => {
  //   const token = captchaRef.current.getValue()
  //   send(
  //     'service_roxp2n8',
  //     'template_d6rrhyt',
  //     {
  //       ...values,
  //       'g-recaptcha-response': token,
  //     },
  //     'i0xGfmqONO5OrVi-a',
  //   )
  //     .then((response) => {
  //       console.log('SUCCESS!', response.status, response.text)
  //       NotificationManager.success('Success message', 'Email bol odoslaný.', 3000)
  //     })
  //     .catch((err) => {
  //       console.log('FAILED...', err)
  //       NotificationManager.error(
  //         'Warning message',
  //         'Email nebol odoslaný. Vyskytla sa chyba.',
  //         3000,
  //       )
  //     })
  // }

  // const validationSchema = Yup.object({
  //   firstname: Yup.string()
  //     .required()
  //     .min(1, 'Krstné meno dieťaťa je hodnota, ktorú je potrebné vyplnit'),
  //   lastname: Yup.string()
  //     .required()
  //     .min(1, 'Priezvisko dieťaťa je hodnota, ktorú je potrebné vyplnit'),
  //   email: Yup.string().email().required().min(1, 'Email je hodnota, ktorú je potrebné vyplnit'),
  //   phone: Yup.string().required().min(1, 'Telefónne číslo je hodnota, ktorú je potrebné vyplnit'),
  //   message: Yup.string().optional().nullable(),
  //   event: Yup.string().optional().nullable(),
  // })

  return (
    <div>
      {/* Contact form element & details section with custom paddings */}
      <section id="prihlaska" className="hg_section pb-80" style={{ marginTop: '-50px' }}>
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-9 col-lg-9 mb-sm-30 pt-50">
              {registrationHeading}
              <div className="contactForm">
                <div
                  data-steamo-registration
                  data-form={formKey}
                  data-locale="sk"
                  data-variant="motivational"
                  data-source="bjjlevice_web"
                  data-logo-url="https://nbg1.your-objectstorage.com/k8s-steamo-bck/organization/invoice-logo-9c8a328f-73c6-44d1-8f75-d7ab8019985b.png"
                  data-logo-alt="Gracie Jiu Jitsu Levice"
                />
                <noscript>
                  <p>
                    <a className="btn btn-fullcolor" href={publicFormUrl}>
                      Vyplniť online prihlášku
                    </a>
                  </p>
                </noscript>

                {/* <Formik
                  initialValues={defaultValues}
                  validationSchema={validationSchema}
                  onSubmit={async (values, { resetForm }) => {
                    await onSubmit(values)
                    resetForm()
                  }}
                >
                  <Form className="contact_form row">
                    <Field name="event" type="hidden" />

                    <div className="cf_response" />
                    <div className="col-sm-6 kl-fancy-form">
                      <Field
                        name="firstname"
                        id="cf_firstname"
                        className="form-control"
                        placeholder={t('yourFirstname')}
                        tabIndex={1}
                        maxLength={35}
                        required
                        type="text"
                      />
                      <div className="text-danger">
                        <strong>
                          <ErrorMessage name="firstname" />
                        </strong>
                      </div>

                      <label className="control-label">{t('firstname').toUpperCase()}</label>
                    </div>

                    <div className="col-sm-6 kl-fancy-form">
                      <Field
                        name="lastname"
                        id="cf_lastename"
                        className="form-control"
                        placeholder={t('yourLastname')}
                        tabIndex={1}
                        maxLength={35}
                        required
                        type="text"
                      />
                      <div className="text-danger">
                        <strong>
                          <ErrorMessage name="lastname" />
                        </strong>
                      </div>
                      <label className="control-label">{t('lastname').toUpperCase()}</label>
                    </div>

                    <div className="col-sm-12 kl-fancy-form">
                      <Field
                        name="email"
                        id="cf_email"
                        className="form-control h5-email"
                        placeholder={t('yourEmail')}
                        tabIndex={1}
                        maxLength={50}
                        required
                        type="text"
                      />
                      <div className="text-danger">
                        <strong>
                          <ErrorMessage name="email" />
                        </strong>
                      </div>

                      <label className="control-label">{t('email').toUpperCase()}</label>
                    </div>

                    <div className="col-sm-12 kl-fancy-form">
                      <Field
                        name="phone"
                        id="cf_phone"
                        className="form-control"
                        placeholder="Telefonny kontakt"
                        tabIndex={1}
                        maxLength={50}
                        required
                        type="text"
                      />
                      <div className="text-danger">
                        <strong>
                          <ErrorMessage name="subject" />
                        </strong>
                      </div>

                      <label className="control-label">Telefónny kontakt</label>
                    </div>

                    <div className="col-sm-12 kl-fancy-form">
                      <Field
                        component="textarea"
                        name="message"
                        id="cf_message"
                        className="form-control"
                        cols={30}
                        rows={10}
                        placeholder="Spáva je nepovinné pole. Slúži pre prípad, že nám chcete zanechat doplnkovú informáciu, napr. v detských programoch vek a výškla dieťaťa."
                        tabIndex={4}
                      />
                      <div className="text-danger">
                        <strong>
                          <ErrorMessage name="message" />
                        </strong>
                      </div>
                      <label className="control-label">{t('message').toUpperCase()}</label>
                    </div>

                    <div className="col-sm-12 mb-30 pb-10 pt-10 border">
                      <label className="control-label">
                        <span>
                          <strong>
                            ZASLANÍM PRIHLÁŠKY UDEĽUJEM SÚHLAS, V SÚLADE S PLATNÝM ZÁKONOM O OCHRANE
                            OSOBNÝCH ÚDAJOV A BERIEM NA VEDOMIE PRAVIDLÁ A PODMIENKY ÚČASTI
                          </strong>
                        </span>
                        <ol className="list-group list-group-numbered">
                          <li>
                            {' '}
                            * <Link to="/gdpr">Zásady spracúvania osobných údajov (GDPR)</Link>
                          </li>
                        </ol>
                      </label>
                    </div>

                    <div className="col-sm-6">
                      <ReCAPTCHA
                        sitekey="6LdiYGAkAAAAAB896FlVk3v6yxe9A5-3YTgrFtXF"
                        ref={captchaRef}
                      />
                    </div>
                    <div className="col-sm-6 text-right">
                      <button className="btn btn-fullcolor" type="submit">
                        Prihlásiť
                      </button>
                    </div>
                  </Form>
                </Formik> */}
              </div>
              {/*/ Contact form element */}
            </div>
            {/*/ col-sm-12 col-md-9 col-lg-9 mb-sm-30 */}
            <div className="col-sm-12 col-md-3 col-lg-3 pt-50">
              {/* Contact details */}
              <div className="text_box">
                {/* Title */}
                <h3 className="kl-iconbox__title">Prihláška</h3>
                {/* <h4 style={{fontSize: "100%"}}><strong>Nábor 2023 / 2024</strong></h4> */}
                <br />
                {/* Sub-title */}
                <p>
                  <i className="fa fa-at"></i>{' '}
                  <a href="mailto:info@bjjlevice.sk">info@bjjlevice.sk</a>
                  <br />
                  <i className="fa fa-phone"></i> <span>0918 107 782</span>
                </p>
              </div>
              {/*/ Contact details */}

              <div className="text-center card" style={{ borderColor: '#cd2122' }}>
                <div style={{ margin: '10px' }}>
                  <div className="pb-30">{/* <img src="/images/15.png" alt="15% zlava" /> */}</div>
                  {/* <div className="fs-m reset-line-height">
                
                <strong className="kl-iconbox__title">Ceny</strong> deti 8-12 rokov
              </div> */}

                  {/* <div style={{weight: "999"}} className="pb-10">AKTUÁLNA CENA JE</div> */}
                  {/* <div style={{fontSize: "200%", weight: "999"}}><strong>139 &euro;</strong></div> */}
                  {/* </div> */}

                  {/* <div className="nlbox--hugediscount text-center-sm" /> */}

                  <div className="fs-m reset-line-height mb-30">
                    <div className="kl-iconbox__title">Ponúkame zľavy :</div>
                    <ul className="zlavy">
                      {/* <li>pre druhého člena rodiny 15%</li> */}
                      {/* <li>pre každého dalšieho člena rodiny 25%</li> */}
                      <li>pre každého dalšieho člena rodiny 20%</li>
                      <li>pri platbe na rok vopred 10%</li>
                    </ul>
                  </div>

                  {/* <div className="nlbox--hugediscount text-center-sm" /> */}

                  {/* <div className="fs-m reset-line-height mb-30">
                Prihláste svoje dieťa už dnes. 
              </div> */}
                </div>
              </div>
            </div>
            {/*/ col-sm-12 col-md-3 col-lg-3 */}
          </div>
          {/*/ .row */}
        </div>
        {/*/ .container */}
      </section>
      {/*/ Contact form element & details section with custom paddings */}
    </div>
  )
}
export default NaborFormular
